export const POPPER_Z_INDEX = 1300;

export const POPPER_MARGIN_THRESHOLD = 16;

export const MAX_SIZE_MODIFIER = {
  name: 'maxSize',
  enabled: true,
  phase: 'beforeWrite' as const,
  requires: ['computeStyles'],
  fn: ({ state }: { state: any }) => {
    const refRect = state.elements.reference.getBoundingClientRect();
    const maxH = window.innerHeight - refRect.bottom - POPPER_MARGIN_THRESHOLD;
    const maxW = window.innerWidth - refRect.left - POPPER_MARGIN_THRESHOLD;
    state.elements.popper.style.setProperty('--paper-max-h', `${maxH}px`);
    state.elements.popper.style.setProperty('--paper-max-w', `${maxW}px`);
  },
};

export const RECENT_LIMIT = 5;
